"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlookSidebar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("@/app/shared/constants");
const handlers_1 = require("@/app/shared/handlers");
const helpers_1 = require("@/app/shared/helpers");
const string_1 = require("@/app/shared/helpers/string/string");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const sidebar_1 = require("@/app/shared/pages/sidebar");
const path_1 = require("@/app/shared/router/path");
const global_1 = require("@/app/shared/store/global");
const actions_1 = require("@/wrapper/actions");
const avatar_1 = require("primereact/avatar");
const button_1 = require("primereact/button");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const OutlookSidebar = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const dialogRef = (0, react_1.useRef)(null);
    const user = (0, react_redux_1.useSelector)(global_1.globalSelectors.selectUser);
    const role = (0, react_redux_1.useSelector)(global_1.globalSelectors.selectRole);
    async function handleLogout() {
        dispatch(global_1.globalActions.handleLogout());
        (0, handlers_1.handleDialogClose)(undefined, dialogRef);
    }
    const onReceiveMessage = (message) => {
        const handlers = {
            [constants_1.RegularMessage.SCHEDULER_INSERT_GUESTS_AND_SUBJECT]: handlers_1.InsertGuestsAndSubject,
            [constants_1.RegularMessage.SCHEDULER_COPY_LINK]: handlers_1.InsertCopyLink,
            [constants_1.RegularMessage.SCHEDULER_INSERT_SPOTS]: handlers_1.InsertSlots,
            [constants_1.RegularMessage.SCHEDULER_DIALOG_CLOSE]: handlers_1.handleDialogClose,
            [constants_1.RegularMessage.SCHEDULER_LOGOUT]: handleLogout,
        };
        const handler = handlers[message.type];
        if (handler)
            handler(message.payload, dialogRef);
    };
    const collectAuthStorage = () => {
        const cognitoData = Object.entries(localStorage)
            .filter(([key]) => key.startsWith('CognitoIdentityServiceProvider'))
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
        return {
            ...cognitoData,
            [helpers_1.Storage.Key.SERVER_SALESFORCE_INSTANCE_URL]: helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_INSTANCE_URL) || '',
            [helpers_1.Storage.Key.SERVER_ENVIRONMENT]: helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_ENVIRONMENT) || '',
            [helpers_1.Storage.Key.SERVER_TYPE]: helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_TYPE) || '',
            [helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN]: helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN) || '',
        };
    };
    const sendAuthToDialog = (authStorage, subject, recipientsEmails) => {
        dialogRef.current?.messageChild(JSON.stringify({ type: constants_1.RegularMessage.INIT_AUTH_STORAGE, payload: { storage: authStorage, subject, recipientsEmails } }));
    };
    const handleShowDialogPopup = async () => {
        const { subject } = await (0, actions_1.getSubject)();
        const { contacts } = await (0, actions_1.getOutlookRecipients)();
        const authStorage = collectAuthStorage();
        const url = helpers_1.query.set(path_1.PathExtension.WRAPPER, {
            extensionIntegration: constants_1.ExtensionIntegration.OUTLOOK,
        });
        const popupResponse = await helpers_1.OutlookPopup.open(url, { width: sidebar_1.SIDEBAR_POPUP_WIDTH, height: sidebar_1.SIDEBAR_POPUP_HEIGHT });
        if (popupResponse instanceof helpers_1.PromiseTimeoutError || popupResponse instanceof Error) {
            throw popupResponse;
        }
        dialogRef.current = popupResponse;
        helpers_1.OutlookPopup.onMessage((message) => {
            if (message.type === constants_1.RegularMessage.DIALOG_AUTH_READY) {
                sendAuthToDialog(authStorage, subject, contacts);
                return;
            }
            onReceiveMessage(message);
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: 'flex flex-column', children: (0, jsx_runtime_1.jsx)(button_1.Button, { label: labels_1.default.ACTIVE_TAB_SIDEBAR_CREATE_MEETING_BUTTON, size: 'large', className: 'w-full h-48px', onClick: handleShowDialogPopup }) }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-24px mt-auto', children: [(0, jsx_runtime_1.jsx)("div", { className: 'h-1px bg-gray-20' }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex-left-center gap-8px', children: [(0, jsx_runtime_1.jsxs)("div", { className: 'w-32px h-32px relative', children: [(0, jsx_runtime_1.jsx)(avatar_1.Avatar, { label: string_1.StringUtil.getInitials(user?.fullName), image: user?.avatar || undefined, imageFallback: 'default', size: 'large' }), (0, jsx_runtime_1.jsx)("div", { className: 'w-8px h-8px border-radius-4px bg-green-100 absolute bottom-4px right-0 translate-right-4px' })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-4px', children: [(0, jsx_runtime_1.jsx)("span", { className: 'text-label-s-med', children: user?.fullName }), (0, jsx_runtime_1.jsx)("span", { className: 'text-label-xs-reg text-gray-60', children: role })] })] }), (0, jsx_runtime_1.jsx)(button_1.Button, { label: labels_1.default.ACTIVE_TAB_SIDEBAR_WELCOME_LOGOUT_BUTTON, onClick: handleLogout, size: 'large', outlined: true, className: 'w-full h-48px' })] })] }));
};
exports.OutlookSidebar = OutlookSidebar;
